import {Flex, LineHeader, SubTitleWrap} from "@FRAMEWORK/ui/desktop/layout";
import {StackList} from "@FRAMEWORK/ui/desktop/list";
import styled, {css} from "styled-components";
import SpriteImage from "@PUBLIC/P/images/ico/ico_spr.png";
import {Ellipsis} from "@FRAMEWORK/ui/desktop/text";
import EventImage from "@PUBLIC/P/images/content/event/yellowpangdeal/img_yellow_sprite.png";
import LiveImage from "@PUBLIC/P/images/content/event/yellowlive/img_live_sprite.png";

const Wrap = styled.div`
	margin-top: 10px;
`;

const HeaderWrap = styled(LineHeader)`
	flex-wrap: wrap;
	flex-direction: column;

	@media print {
		h2 {
			font-size: 46px;
		}
	}
`;

const SummaryWrap = styled.div`
	display: flex;
	gap: 20px;
	margin: 20px 0 5px;

	> dl {
		display: flex;
		gap: 10px;
		line-height: 1;
		font-size: var(--default-size);
		letter-spacing: -0.025em;

		dt {
			color: var(--default-color);
		}
		dd {
			color: var(--emp-color);
		}
	}

	@media print {
		dl {
			font-size: 20px;
		}
	}
`;

const ProductNumber = styled(StackList)`
	li {
		font-size: 15px;
	}

	span {
		color: var(--emp-color);
	}
	@media print {
		li {
			font-size: 30px;
		}
	}
`;

const TextNumber = styled.span`
	padding-left: 9px;
`;

const ButtonBox = styled(Flex)`
	gap: 20px;

	span {
		display: flex;
		font-size: var(--basic-size);
		align-items: center;
		gap: 8px;
		cursor: pointer;
	}
`;

const SlideWrap = styled.div`
	margin-top: 30px;
`;

const ScheduleIconList = styled.ul`
	display: flex;
	padding: 28px 40px;
	margin-top: 20px;
	background-color: var(--disabled-color);
	justify-content: center;
	gap: 35px;
	text-align: center;

	li {
		display: flex;
		align-items: center;
		flex-direction: column;
		font-size: var(--default-size);
		color: var(--emp-color);
		line-height: 1.4;
		gap: 11px;
	}

	@media print {
		li {
			font-size: 20px;
		}
	}
`;

const ScheduleIcon = styled.span<{icon: string}>`
	position: relative;
	display: block;
	width: 75px;
	height: 75px;
	background-color: #fff;
	border-radius: 50%;

	&:after {
		position: absolute;
		top: 50%;
		left: 50%;
		display: block;
		transform: translate(-50%, -50%);
		content: "";
	}
	${props =>
		props.icon === "schedule" &&
		`
        &:after {
            width: 32px;
            height: 32px;
            background: url(${SpriteImage}) no-repeat 0 -204px;
        }
    `}
	${props =>
		props.icon === "air" &&
		`
        &:after {
            width: 42px;
            height: 26px;
            background: url(${SpriteImage}) no-repeat -36px -204px;
        }
    `}
	${props =>
		props.icon === "air-premium" &&
		`
		&:after {
			width: 42px;
			height: 38px;
			background: url(${SpriteImage}) no-repeat -35px -242px;
		}
	`}
    ${props =>
		props.icon === "decide" &&
		`
		&:after {
			width: 30px;
			height: 36px;
			background: url(${SpriteImage}) no-repeat -81px -204px;
		}
    `}
    ${props =>
		props.icon === "guide" &&
		`
		&:after {
			width: 30px;
			height: 34px;
			background: url(${SpriteImage}) no-repeat -114px -204px;
		}
    `}
    ${props =>
		props.icon === "expenses" &&
		`
		&:after {
			width: 36px;
			height: 36px;
			background: url(${SpriteImage}) no-repeat -150px -204px;
		}
    `}
    ${props =>
		props.icon === "seat" &&
		`
		&:after {
			width: 38px;
			height: 34px;
			background: url(${SpriteImage}) no-repeat -193px -204px;
		}
    `}
    ${props =>
		props.icon === "insurance" &&
		`
		&:after {
			width: 30px;
			height: 36px;
			background: url(${SpriteImage}) no-repeat -235px -204px;
		}
    `}
    ${props =>
		props.icon === "charge" &&
		`
		&:after {
			width: 34px;
			height: 34px;
			background: url(${SpriteImage}) no-repeat -270px -204px;
		}
    `}
    ${props =>
		props.icon === "free" &&
		`
		&:after {
			width: 36px;
			height: 36px;
			background: url(${SpriteImage}) no-repeat -307px -204px;
		}
    `}
    ${props =>
		props.icon === "shopping" &&
		`
		&:after {
			width: 32px;
			height: 32px;
			background: url(${SpriteImage}) no-repeat -345px -203px;
		}
    `}
	${props =>
		props.icon === "green" &&
		`
		&:after {
			width: 38px;
			height: 36px;
			background: url(${SpriteImage}) no-repeat -82px -242px;
		}
    `}
	${props =>
		props.icon === "caddy" &&
		`
		&:after {
			width: 36px;
			height: 44px;
			background: url(${SpriteImage}) no-repeat -122px -242px;
		}
    `}
	${props =>
		props.icon === "bus" &&
		`
		&:after {
			width: 36px;
			height: 36px;
			background: url(${SpriteImage}) no-repeat -160px -242px;
		}
    `}
	${props =>
		props.icon === "ship" &&
		`
		&:after {
			width: 38px;
			height: 38px;
			background: url(${SpriteImage}) no-repeat -200px -242px;
		}
    `}
	${props =>
		props.icon === "train" &&
		`
		&:after {
			width: 32px;
			height: 36px;
			background: url(${SpriteImage}) no-repeat -240px -242px;
		}
    `}
	${props =>
		props.icon === "transport-not" &&
		`
		&:after {
			width: 38px;
			height: 38px;
			background: url(${SpriteImage}) no-repeat -274px -242px;
		}
    `}
`;

const OptionBox = styled.div`
	display: flex;
	height: 80px;
	margin-top: 20px;
	border: 1px solid #eeecd5;
	background-color: #fbf9e1;
	box-sizing: border-box;
	justify-content: center;
	align-items: center;
	gap: 11px;

	// &:before {
	// 	display: block;
	// 	width: 27px;
	// 	height: 27px;
	// 	background: url(${SpriteImage}) no-repeat -82px 0px;
	// 	content: "";
	// }

	p {
		font-size: var(--medium-size);
		color: var(--emp-color);

		strong {
			font-family: "PT-regular";
		}
	}

	@media print {
		font-size: 24px;
		strong,
		p {
			font-size: 24px;
		}
	}
`;

const CertifiedBox = styled.div`
	margin-top: 40px;
	border: 1px solid var(--line-color);
`;

const CertifiedBanner = styled.div<{noIcon?: boolean; bgColor?: string}>`
	display: flex;
	height: 79px;
	background-color: ${props => (props.bgColor ? props.bgColor : "#f3f3f3")};
	justify-content: center;
	align-items: center;
	gap: 18px;

	&:before {
		display: block;
		width: 32px;
		height: 22px;
		background: url(${SpriteImage}) no-repeat -114px 0px;
		content: "";
	}
	p {
		font-size: 20px;
		color: var(--emp-color);

		strong {
			font-family: "PT-regular";
		}
	}

	${props =>
		props.noIcon &&
		`
	&:before {
		display: none;
	}
	`}

	@media print {
		font-size: 24px;
		strong,
		p {
			font-size: 24px;
		}
	}
`;

const CertifiedContent = styled.div`
	position: relative;
	padding: 30px 39px 27px;
	font-size: var(--default-size);

	h5 {
		padding-bottom: 14px;
		font-size: var(--default-size);
		font-weight: bold;
		color: var(--emp-color);
		line-height: 1;
	}

	p {
		line-height: 1.6;
	}

	@media print {
		font-size: 24px;
		h5,
		p {
			font-size: 24px;
		}
	}
`;

const CertifiedBannerButton = styled.div`
	position: absolute;
	right: 39px;
	bottom: 40px;
`;

const NoteBox = styled.div`
	padding: 38px 40px 36px;
	margin-top: 40px;
	background-color: #f3f3f3;
	font-size: var(--default-size);

	h4,
	p {
		padding-left: 28px;
		color: var(--emp-color);
	}

	h4 {
		position: relative;
		margin-bottom: 5px;

		&:before {
			position: absolute;
			left: 0;
			top: 50%;
			display: block;
			width: 18px;
			height: 18px;
			background: url(${SpriteImage}) no-repeat 0px -328px;
			transform: translateY(-50%);
			content: "";
		}
	}

	p {
		line-height: 1.6;
	}
`;

const EventBanner = styled.div`
	margin-top: 40px;

	a {
		display: block;
		height: 75px;
		font-size: 0;
	}
	img {
		width: 100%;
		height: 100%;
	}
`;

const DescriptionWrap = styled.div`
	position: relative;
`;

const DescriptionContent = styled.div`
	width: 910px;
`;

const SubTitleFlexWrap = styled(SubTitleWrap)`
	position: relative;
	display: flex;
	align-items: center;
	justify-content: space-between;

	button {
		position: absolute;
		right: 0;
	}

	@media print {
		h3 {
			font-size: 36px;
		}
		+ div {
			font-size: 24px;
			line-height: 1.6;
			p,
			h5,
			h6 {
				font-size: 24px;
				line-height: 1.6;
			}
			ul li,
			ol li {
				font-size: 24px;
				line-height: 1.6;
			}
			table {
				tr {
					th,
					td,
					td p {
						font-size: 24px;
						line-height: 1.6;
					}
				}
			}
		}
	}
`;

const SimpleItinerary = styled.div`
	border: 1px solid var(--line-color);
	border-top: 1px solid var(--emp-color);
`;

const ItineraryTable = styled.div`
	padding: 0 40px;
	font-size: var(--default-size);

	tr {
		border-bottom: 1px solid var(--line-color);

		&:last-child {
			border-bottom: none;
		}
	}

	th {
		padding: 30px 0;
		font-size: 20px;
		font-family: "PT-medium";
		color: var(--emp-color);
		vertical-align: top;
		text-align: left;
		line-height: 1;
	}

	td {
		padding: 30px 0;
		line-height: 1.6;
	}

	@media print {
		th {
			font-size: 28px;
		}
		td {
			font-size: 26px;
			line-height: 28px;
		}
	}
`;

const airlineText = styled.div`
	padding-bottom: 30px;
`;

const ItineraryAirplaneInfo = styled.div``;

const AirplaneInfoCaution = styled.p`
	position: relative;
	display: block;
	margin-top: 23px;
	padding-left: 20px;
	word-break: keep-all;

	&:before {
		position: absolute;
		top: -1px;
		left: 0;
		content: "※";
	}

	@media print {
		line-height: 34px;
	}
`;

const AirplaneInfoContent = styled.div`
	display: flex;
	max-width: 650px;
	flex-direction: column;
	line-height: 1;

	> div {
		+ div {
			padding-top: 20px;
			margin-top: 20px;
			border-top: 1px dashed var(--line-color);
		}
	}

	@media print {
		gap: 30px;
		line-height: 34px;
		> div {
			justify-content: space-between;
		}
	}
`;

const AirplaneName = styled.span`
	margin-right: 10px;
	color: var(--default-color);
`;

const AirplaneIcon = styled.i`
	display: block;
	width: 14px;
	height: 10px;
	margin: 0 10px;
	background: url(${SpriteImage}) no-repeat -265px 0px;
	content: "";

	@media print {
		width: 24px;
		height: 10px;
	}
`;

const AirplaneInfo = styled.div`
	@media print {
		flex: 0 0 calc(50% - 74px);
		margin-bottom: auto;
	}
`;

const AirplaneNumber = styled.span`
	padding-left: 10px;
	padding-right: 15px;
	font-family: "PT-medium";
	color: #3094fb;

	@media print {
		display: inline-block;
	}
`;

const AirplaneDepart = styled.span`
	padding-right: 20px;
	font-family: "PT-medium";
	color: #3094fb;

	@media print {
		display: inline-block;
	}
`;

const AirplaneDay = styled.span`
	color: var(--emp-color);

	@media print {
		display: inline-block;
	}
`;

const AirplaneTime = styled.span`
	color: #888;
	&::before {
		display: inline-block;
		width: 1px;
		height: 12px;
		margin-right: 15px;
		background-color: var(--line-color);
		content: "";
	}

	@media print {
		display: block;
		padding-left: 0;
	}
`;

const VisitingCityText = styled.div`
	span {
		&:after {
			padding: 0 8px;
			content: "→";
		}

		&:last-child:after {
			display: none;
		}
	}
`;

const ScheduleWrap = styled.div`
	padding: 40px 38px;
	background-color: var(--disabled-color);
`;

const ScheduleListWrap = styled.div`
	overflow: hidden;
`;

const ScheduleList = styled.ul`
	display: flex;
	gap: 10px;
	flex-direction: column;

	> li {
		display: grid;
		width: 100%;
		grid-template-columns: 120px auto;
		grid-template-rows: 1fr;
	}
`;

const ScheduleListDay = styled.div`
	display: flex;
	padding: 18px 0 18px 30px;
	background-color: #59647c;
	font-family: "PT-medium";
	font-size: var(--medium-size);
	color: #fff;
	align-items: center;

	@media print {
		font-size: 26px;
	}
`;

const ScheduleSummary = styled.ul`
	padding: 17px 20px;
	border: 1px solid var(--line-color);
	border-left: none;
	background-color: #fff;
	font-size: var(--default-size);
	align-items: center;

	> li {
		display: inline;
		word-break: break-word;

		&:after {
			padding: 0 8px;
			content: ">";
		}

		&:last-of-type:after {
			display: none;
		}
	}

	@media print {
		font-size: 26px;

		li {
			font-size: 26px;
		}
	}
`;

const TouristSpot = styled.ul`
	display: inline;

	li {
		display: inline;

		&:before {
			padding: 0 3px;
			content: "-";
		}

		@media print {
			font-size: 26px;
		}
	}
`;

const ScheduleNotice = styled.p`
	margin-top: 12px;
	font-size: var(--basic-size);

	@media print {
		font-size: 24px;
	}
`;

const ProductPriceTable = styled.div`
	margin-bottom: 20px;
	table {
		th {
			height: 80px;
		}

		td {
			padding: 20px 0 9px;
			vertical-align: top;
		}
	}

	@media print {
		table {
			th {
				font-size: 26px;
				span {
					font-size: 18px;
				}
			}
			td {
				font-size: 26px;
			}
		}
		+ ul li {
			font-size: 24px;
			&::before {
				top: 15px;
			}
		}
	}
`;

const AgeLimitBox = styled.div`
	position: relative;
	line-height: 1;

	span {
		color: var(--default-color);
	}
`;

const AgeLimit = styled.span`
	display: block;
	margin-top: 7px;
	font-size: var(--default-size);
	color: var(--default-color);
	line-height: 1;
`;

const PriceBox = styled.div`
	em {
		display: block;
		margin-bottom: 10px;
		color: var(--emp-color);
		line-height: 1;

		strong {
			font-size: 20px;
		}

		+ span {
			display: block;
			margin-top: 0;
		}
	}

	span {
		font-size: 14px;
		margin-top: 50px;
	}

	strong {
		margin-right: 3px;
		font-family: "PT-medium";
		font-weight: normal;
	}

	@media print {
		em {
			font-size: 26px;
			strong {
				font-size: 26px;
			}
		}
		span {
			font-size: 20px;
		}
	}
`;

const CouponTotalText = styled.p`
	font-size: var(--default-size);
	em {
		color: var(--emp-color);
	}
`;

const CouponList = styled.ul`
	display: flex;
	margin-bottom: 20px;
	flex-direction: column;
	gap: 10px;

	@media print {
		+ ul li {
			font-size: 24px;
			&::before {
				top: 15px;
			}
		}
	}
`;

const CouponItem = styled.li`
	display: flex;
	height: 100px;
	padding: 20px 30px;
	border: 1px solid var(--line-color);
	border-radius: 8px;
	align-items: center;
	flex-flow: row nowrap;
	box-sizing: border-box;
`;

const CouponIcon = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;

	i {
		position: relative;
		display: flex;
		height: 60px;
		min-width: 94px;
		background-color: #ffcb31;
		font-size: var(--regular-size);
		font-family: "PT-semibold";
		color: #fff;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;

		&:after {
			position: absolute;
			right: 6px;
			display: block;
			width: 2px;
			height: 36px;
			border-radius: 8px;
			background: rgba(255, 255, 255, 0.4);
			content: "";
		}
	}
	&:before,
	&:after {
		width: 8px;
		height: 60px;
		content: "";
	}
	&:before {
		background: url(${SpriteImage}) no-repeat -82px -32px;
	}
	&:after {
		background: url(${SpriteImage}) no-repeat -96px -32px;
	}
`;

const CouponTitle = styled.div`
	display: flex;
	flex-direction: column;
	gap: 5px;
	margin-left: 20px;
	flex-grow: 2;
`;

const CouponPrice = styled.span`
	display: flex;
	align-items: center;
	gap: 6px;
	font-size: 20px;
	font-family: "PT-semibold";
	color: var(--emp-color);

	@media print {
		font-size: 26px;
	}
`;

const CouponTagGroup = styled.span`
	display: flex;
	align-items: center;
	gap: 4px;
`;

const CouponTag = styled.span<{type?: "limited" | "impending"}>`
	display: inline-flex;
	align-items: center;
	height: 18px;
	line-height: 18px;
	padding: 0 8px;
	border-radius: 8px;
	border: 1px solid var(--line-color);
	font-family: "PT-bold";
	font-size: 11px;
	white-space: nowrap;
	color: var(--caption-color);
	box-sizing: border-box;

	${({type}) =>
		type === "limited" &&
		css`
			border-color: var(--alert-color);
			background-color: var(--alert-color);
			color: #fff;
			border-radius: 8px 8px 8px 0;
		`}

	${({type}) =>
		type === "impending" &&
		css`
			border-color: var(--alert-color);
			background-color: #ffeceb;
			color: var(--alert-color);
		`}
`;

const CouponName = styled.span`
	${Ellipsis(1)};
	font-family: "PT-medium";
	font-size: var(--regular-size);
	color: var(--emp-color);
	line-height: 1.3;

	@media print {
		font-size: 20px;
	}
`;

const CouponNameWrap = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	gap: 4px;
`;

const TooltipWrap = styled.span`
	position: relative;
	display: inline-flex;
	flex: 0 0 auto;
`;

const TooltipButton = styled.button`
	position: relative;
	flex: 0 0 auto;
	width: 20px;
	height: 20px;
	background-image: url(${SpriteImage});
	background-position: -53px -371px;
	background-color: transparent;
`;

const Tooltip = styled.div`
	position: absolute;
	left: 50%;
	bottom: calc(100% + 5px);
	margin-bottom: 8px;
	transform: translateX(-50%);
	z-index: 1;
	display: inline-flex;
	width: 280px;
	padding: 12px;
	border-radius: 8px;
	border: 1px solid var(--border-color);
	background: var(--disable-bg-color);
	box-sizing: border-box;
	font-size: 12px;
	font-family: "PT-medium";
	color: var(--caption-color);
	line-height: 1.5;

	&::before {
		position: absolute;
		bottom: -6px;
		left: 50%;
		transform: translateX(-50%) rotate(45deg);
		width: 11px;
		height: 11px;
		background: var(--disable-bg-color);
		border-right: 1px solid var(--border-color);
		border-bottom: 1px solid var(--border-color);
		content: "";
	}
`;

const CouponButtonWrap = styled.div`
	display: flex;
	gap: 16px;
	flex-shrink: 0;
	> button {
		min-width: 80px;
	}
`;

const CouponExpired = styled.div`
	display: flex;
	align-items: center;
	font-size: var(--basic-size);
	color: var(--default-color);
	line-height: 1.3;

	@media print {
		font-size: 20px;
	}
`;

const BannerYellowpangdeal = styled.div`
	position: relative;
	display: flex;
	margin-top: 20px;
	justify-content: end;

	&:before {
		position: absolute;
		left: 0;
		display: block;
		width: 80%;
		height: 100%;
		background: linear-gradient(to top, #ffde2f 58px, #fff 17px);
		content: "";
	}

	a {
		display: flex;
		z-index: 1;
		align-items: end;
	}
`;

const PangdealPrice = styled.div`
	width: 667px;
	height: 75px;
	background: url(${EventImage}) 0px -202px/ 1200px 600px no-repeat;
`;

const PangdealText = styled.div`
	display: flex;
	height: 58px;
	padding-left: 169px;
	margin-top: 17px;
	color: #222;
	font-size: 20px;
	align-items: center;
	gap: 30px;

	p {
		position: relative;
		line-height: 1;
		color: var(--emp-color);

		&:not(:first-child)::before {
			position: absolute;
			left: -15px;
			top: 50%;
			width: 1px;
			height: 14px;
			background-color: #bbb;
			transform: translateY(-50%);
			content: "";
		}
	}
`;

const PangdealProduct = styled.span`
	font-family: "PT-medium";
	color: var(--red-color);
`;

const PangdealDate = styled.span`
	font-family: "PT-medium";
	color: var(--blue-color);
`;

const PangdealLink = styled.div`
	position: relative;
	display: flex;
	height: 58px;
	width: 140px;
	background-color: #ffc72c;
	color: #222;
	font-size: 14px;
	line-height: 1.42;
	align-items: center;

	span {
		position: absolute;
		left: 50%;
		padding-right: 17px;
		transform: translateX(-50%);

		&:after {
			position: absolute;
			right: 0px;
			bottom: 2px;
			width: 7px;
			height: 7px;
			border-top: 1px solid #333;
			border-left: 1px solid #333;
			transform: translate(-50%, -50%) rotate(135deg);
			content: "";
		}
	}
`;

const BannerYellowLive = styled.div`
	position: relative;
	display: flex;
	width: 100%;
	height: 75px;
	margin-top: 20px;
	background-color: #ff9574;

	&:before {
		position: absolute;
		left: 0;
		display: block;
		width: 100%;
		height: 100%;
		background: url(${LiveImage}) 0px -80px/ 1200px 600px no-repeat;
		content: "";
	}
	&::after {
		position: absolute;
		right: 0;
		bottom: 0;
		display: block;
		width: 103px;
		height: 100%;
		background: url(${LiveImage}) 0px 0px/ 1200px 600px no-repeat;
		content: "";
	}
	a {
		display: flex;
		z-index: 1;
		align-items: center;
		width: 100%;
		height: 100%;
		padding-left: 175px;
	}
`;

const LiveText = styled.p`
	display: flex;
	flex: 1 1 100%;
	align-items: center;
	line-height: 1;
`;

const LiveTit = styled.span`
	margin-right: 40px;
	font-size: 20px;
	color: #fff;
`;

const LiveDate = styled.span`
	margin-right: 10px;
	font-size: 22px;
	color: var(--emp-color);
	font-family: "PT-bold";
`;

const LiveState = styled.span`
	font-size: 20px;
	color: #fff;
	font-family: "PT-medium";
`;

const LiveLink = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	flex: 0 0 106px;
	width: 106px;
	height: 75px;
	font-size: var(--default-size);
	color: var(--emp-color);

	span {
		position: relative;
		line-height: 1;
		&:after {
			position: absolute;
			top: 50%;
			right: -11px;
			width: 6px;
			height: 6px;
			border-top: 1px solid var(--emp-color);
			border-left: 1px solid var(--emp-color);
			transform: translateY(-50%) rotate(135deg);
			content: "";
		}
	}
`;

const TextLink = styled.span`
	a {
		text-decoration: underline;
		color: var(--emp-color);
	}
`;

const NoteBoxWrap = styled.div`
	margin-top: 40px;

	@media print {
		font-size: 24px;
		div {
			h4,
			p {
				font-size: 24px;
			}
		}
	}
`;

const StatusList = styled.ul`
	display: flex;

	> li {
		color: var(--default-color);
	}

	> li:first-child {
		padding-left: 0;
	}
`;

const TagWrap = styled.div`
	display: flex;
	align-items: center;
	gap: 3px;
	@media print {
		> span {
			font-size: 24px;
			height: 32px;
		}
	}
`;

export {
	Wrap,
	HeaderWrap,
	ProductNumber,
	TextNumber,
	TagWrap,
	SlideWrap,
	ButtonBox,
	ScheduleIconList,
	ScheduleIcon,
	OptionBox,
	CertifiedBanner,
	CertifiedBox,
	CertifiedContent,
	CertifiedBannerButton,
	NoteBox,
	EventBanner,
	DescriptionWrap,
	SubTitleFlexWrap,
	SimpleItinerary,
	ItineraryTable,
	airlineText,
	ItineraryAirplaneInfo,
	AirplaneNumber,
	AirplaneDepart,
	AirplaneDay,
	AirplaneTime,
	AirplaneName,
	VisitingCityText,
	ScheduleWrap,
	ScheduleListWrap,
	ScheduleList,
	ScheduleListDay,
	ScheduleSummary,
	TouristSpot,
	ScheduleNotice,
	AirplaneIcon,
	AirplaneInfoContent,
	ProductPriceTable,
	AgeLimitBox,
	AgeLimit,
	PriceBox,
	CouponTotalText,
	CouponList,
	CouponItem,
	CouponIcon,
	CouponTitle,
	CouponExpired,
	BannerYellowpangdeal,
	PangdealPrice,
	PangdealText,
	PangdealProduct,
	PangdealDate,
	PangdealLink,
	DescriptionContent,
	TextLink,
	NoteBoxWrap,
	AirplaneInfoCaution,
	CouponButtonWrap,
	CouponPrice,
	CouponTagGroup,
	CouponTag,
	CouponName,
	CouponNameWrap,
	TooltipWrap,
	TooltipButton,
	Tooltip,
	StatusList,
	AirplaneInfo,
	BannerYellowLive,
	LiveLink,
	LiveText,
	LiveDate,
	LiveState,
	LiveTit,
	SummaryWrap,
};
